import * as form from '../form';

export const foreignBusinessContact = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Name: form.name(xitem.Name),
        Location: form.location(xitem.Location),
        Date: form.datecontrol(xitem.Date),
        Governments: form.country(xitem.Governments),
        Establishment: form.textarea(xitem.Establishment),
        Representatives: form.textarea(xitem.Representatives),
        Purpose: form.textarea(xitem.Purpose),
        SubsequentContacts: form.collection(
          ((xitem.SubsequentContacts || {}).items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                Has: form.branch(yitem.Has),
                Subsequent: form.text(yitem.Subsequent),
                Recent: form.datecontrol(yitem.Recent),
                Future: form.text(yitem.Future),
              },
            };
          })
        ),
        WhoContacted: form.radio(xitem.WhoContacted), // PVQ Only
        AgencyType: form.radio(xitem.AgencyType), // PVQ Only
        AgencyTypeOtherExplanation: form.textarea(xitem.AgencyTypeOtherExplanation), // PVQ Only
        AgencyName: form.text(xitem.AgencyName), // PVQ Only
        AgencyNameNotApplicable: form.notapplicable(xitem.AgencyNameNotApplicable), // PVQ Only
        RepresentativeName: form.name(xitem.RepresentativeName), // PVQ Only
        RepresentativeNameNotApplicable: form.notapplicable(xitem.RepresentativeNameNotApplicable), // PVQ Only
        LocationNotApplicable: form.notapplicable(xitem.LocationNotApplicable), // PVQ Only
        HasFuturePlansToContact: form.branch(xitem.HasFuturePlansToContact), // PVQ Only
        HasFuturePlansToContactExplanation: form.textarea(xitem.HasFuturePlansToContactExplanation), // PVQ Only
      },
    };
  });
  return {
    HasForeignContact: form.branch(data.HasForeignContact),
    List: form.collection(items, (data.List || {}).branch),
  };
};
